import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { IDesignImage } from '../../interfaces/Design/IDesignImage';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/GetApp';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useVrsTranslationState } from '../../context/AppContext/AppContext';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

interface IDesignImageActionsProps {
  color: string;
  image: IDesignImage;
  handleDownload?: (template: IDesignImage) => void;
  handleEdit?: (template: IDesignImage) => void;
  handleExport?: (template: IDesignImage, format?: string) => void;
  handleDelete?: (template: IDesignImage) => void;
}

const DesignImageActions = ({ color, image, handleDownload, handleEdit, handleExport, handleDelete }: IDesignImageActionsProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const { _T } = useVrsTranslationState();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

  const handleExportOption = (format) => {
    if (handleExport) {
      handleExport(image, format);
      handleExportClose();
      handleClose();
    }
  };

  return (
    <>
      <IconButton
        id={`template-action-btn-${image.id.replace(/ /g, '-')}`}
        size="small"
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ color, padding: 0 }}
      >
        <MoreHorizIcon data-testid="MoreHorizIcon" />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1.5,
            minWidth: 180,
            boxShadow: 'none', // Remove box shadow
          },
        }}
      >
        {handleEdit && (
          <MenuItem
            id={`edit-template-btn-${image.id.replace(/ /g, '-')}`}
            onClick={() => {
              handleEdit(image);
              handleClose();
            }}
          >
            <EditIcon sx={{ color, mr: 1 }} data-testid="EditIcon" />
            <Typography sx={{ color }}>{_T('Edit')}</Typography>
          </MenuItem>
        )}
        {handleDownload && (
          <MenuItem
            id={`download-template-btn-${image.id.replace(/ /g, '-')}`}
            onClick={() => {
              console.log('Downloading template:', image);
              handleDownload(image);
              handleClose();
            }}
          >
            <DownloadIcon sx={{ color, mr: 1 }} data-testid="DownloadIcon" />
            <Typography sx={{ color }}>{_T('Download')}</Typography>
          </MenuItem>
        )}

        {handleExport && (
          <MenuItem
            id={`export-template-btn-${image.id.replace(/ /g, '-')}`}
            onClick={handleExportClick}
          >
            <SaveAltIcon sx={{ color, mr: 1 }} data-testid="SaveAltIcon" />
            <Typography sx={{ color }}>{_T('Export')}</Typography>
            <ArrowRightIcon sx={{ color, ml: 'auto' }} />
          </MenuItem>
        )}


        {handleDelete && (
          <MenuItem
            id={`delete-template-btn-${image.id.replace(/ /g, '-')}`}
            onClick={() => {
              handleDelete(image);
              handleClose();
            }}
          >
            <DeleteIcon sx={{ color, mr: 1 }} data-testid="DeleteIcon" />
            <Typography sx={{ color }}>{_T('Delete')}</Typography>
          </MenuItem>
        )}
      </Menu>

      {/* Export Submenu */}
      <Menu
        id="export-submenu"
        anchorEl={exportAnchorEl}
        keepMounted
        open={Boolean(exportAnchorEl)}
        onClose={handleExportClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            minWidth: 180,
            boxShadow: 'none',
          },
        }}
      >
        <MenuItem
          id={`export-ciff-btn-${image.id.replace(/ /g, '-')}`}
          onClick={() => handleExportOption('ciff')}
        >
          <InsertDriveFileIcon sx={{ color, mr: 1 }} />
          <Typography sx={{ color }}>Template</Typography>
        </MenuItem>
        <MenuItem
          id={`export-pdf-btn-${image.id.replace(/ /g, '-')}`}
          onClick={() => handleExportOption('pdf')}
        >
          <PictureAsPdfIcon sx={{ color, mr: 1 }} />
          <Typography sx={{ color }}>PDF</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default DesignImageActions;
